




import Vue from "vue";
import Ice from "@/lib/ice";

type Data = {};
type Method = {};
type Computed = {};
type Props = {};

export default Vue.extend<Data, Method, Computed, Props>({
  name: "vc-launch-page-in-browser",
  mounted() {
    if (Ice.isIce()) {
      Ice.openUrl(window.location.href, true);
    }
  }
});
